import React, { useEffect } from 'react';
import { WarningNotification, ErrorNotification, SuccessNotification, InfoNotification, ExitBtn } from '../../constants/SvgIcons';
import './toast.scss';
import { NOTIFICATION_TYPES } from './toastConstants';

interface ToastProps {
  type: NOTIFICATION_TYPES;
  title: string;
  description?: string;
  view?: boolean;
  onClose: () => void;
  duration?: number;
  persistent?: boolean;
}

const icons = {
  warningNotification: (<WarningNotification className='toast-icon'/>),
 errorNotification: (<ErrorNotification  className='toast-icon'/>),
successNotification: (<SuccessNotification  className='toast-icon'/>),
infoNotification: (<InfoNotification  className='toast-icon'/>)
};

const exitBtn= (<ExitBtn className='toast-exit-icon'/>);

const durationTime = 7000;
const ToastNotification: React.FC<ToastProps> = ({
  type,
  title,
  description,
  view,
  onClose,
  duration = durationTime,
  persistent = false
}) => {

  const [isExiting, setIsExiting] = React.useState(false);
  const transitionDuration = 300;

  useEffect(() => {
    if (!persistent) {
      const timer = setTimeout(() => {
        setIsExiting(true);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, persistent]);

  useEffect(() => {
    if (isExiting && !persistent) {
      const exitTimer = setTimeout(() => {
        onClose();
      }, transitionDuration);
      return () => clearTimeout(exitTimer);
    }
  }, [isExiting, onClose, persistent]);

  return (
    <div className={`toast ${type} ${isExiting ? 'exiting' : ''}`}>
      {icons[type]}
      <div className="toast-content">
        <strong className="toast-title">{title}</strong>
        {description && <p className="toast-description">{description}</p>}
      </div>
      {view && <button className="toast-button">View</button>}
      <button onClick={onClose} className="toast-button exit">{exitBtn}</button>
    </div>
  );
};

export default ToastNotification;